export const updateCategory = (payload?: any) => ({
    type: "@saga/UPDATE_CATEGORY",
    payload
});

